export enum OrganizationState {
  Restricted = 'Restricted',
  Offboarded = 'Offboarded',
  Locked = 'Locked',
  Setup = 'Setup',
  Onboarded = 'Onboarded',
  Active = 'Active',
}
